import createIcon from '../../createIcon';

/**
 * @component @name Dock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAyM0gxNlYyMUg4VjIzWk0xNiAxLjAxTDggMUM2LjkgMSA2IDEuOSA2IDNWMTdDNiAxOC4xIDYuOSAxOSA4IDE5SDE2QzE3LjEgMTkgMTggMTguMSAxOCAxN1YzQzE4IDEuOSAxNy4xIDEuMDEgMTYgMS4wMVpNMTYgMTVIOFY1SDE2VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dock = createIcon('Dock', [
  [
    'path',
    {
      d: 'M8 23H16V21H8V23ZM16 1.01L8 1C6.9 1 6 1.9 6 3V17C6 18.1 6.9 19 8 19H16C17.1 19 18 18.1 18 17V3C18 1.9 17.1 1.01 16 1.01ZM16 15H8V5H16V15Z',
      key: '8km1zk',
    },
  ],
]);

export default Dock;
